<template>
  <div class="xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">从素材库选择{{ fileType }}</div>
          <div class="xc-modal-close" @click="layerClose"></div>
        </div>
        <div class="xc-card-content">
          <form name="material" class="xc-form">
            <div class="xc-form-inline">
              <xc-form-item
                label="播放时长(秒)："
                :error="errors.first('duration')"
                v-if="mix_query.fileType == 'video'"
              >
                <input
                  type="text"
                  name="duration"
                  v-model="data.duration"
                  v-validate="'required|min_value:1'"
                  data-vv-as="播放时长"
                  class="xc-input xc-input-disabled"
                  disabled
                />
              </xc-form-item>
              <xc-form-item
                label="播放时长(秒)："
                required
                :error="errors.first('duration')"
                v-else
              >
                <input
                  type="text"
                  name="duration"
                  v-model="data.duration"
                  v-validate="'required|min_value:1'"
                  data-vv-as="播放时长"
                  class="xc-input"
                  placeholder="请输入播放时长"
                />
              </xc-form-item>
            </div>
          </form>
        </div>
        <div class="xc-modal-body xc-s-df">
          <div class="groups">
            <template v-if="list[0].children.length">
              <xc-tree
                :data.sync="list"
                @expanded="toggleFunc"
                @selected="selectFunc"
                @checked="checkFunc"
                @updated="updateData"
                @init="hasInit"
                linked
                :expand="0"
                label="fileGroupName"
                :key="id"
              ></xc-tree>
            </template>
          </div>
          <div class="xc-row xc-s-flex">
            <div class="xc-card xc-row" style="flex-direction: column">
              <div class="xc-card-content" style="overflow: auto">
                <div class="materials xc-s-df">
                  <template v-if="materials && materials.length">
                    <div
                      class="material-item"
                      v-for="(item, index) in materials"
                      :key="index"
                    >
                      <img :src="item.fileImageUrl" />
                      <input
                        type="radio"
                        name="material"
                        class="xc-checkbox"
                        :value="JSON.stringify(item)"
                        @change="getDuration($event, item)"
                        :key="item.fileId"
                      />
                      <div class="material-item-info">
                        {{ item.fileName }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="xc-modal-footer xc-flex-item">
          <div class="xc-btn-group">
            <div class="xc-btn xc-btn-default" @click="layerClose">取消</div>
            <div class="xc-btn xc-btn-primary" @click="submit">确定</div>
          </div>
          <!-- 分页 -->
          <xc-pagination
            @change="pageChange"
            :page="mix_page"
            :total="mix_total"
            :size="mix_pageSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myLayerImport from "@/libs/myLayer";
import listMixin from "../xc-ui/mixins/list";
// vee-validate验证
import "@/libs/vee-validate";
myLayerImport();
//接口
import material from "@/api/material";
import check from "../utils/grace-checker/check";

export default {
  name: "materialSelect",
  mixins: [listMixin],
  data() {
    return {
      id: 0,
      // 来源渠道 0、节目编辑器（图片上传） 1、素材库（图片上传）
      channel: 0,
      data: {
        duration: null,
      },
      files: [],
      list: [
        {
          fileGroupName: "全部",
          expand: true,
          children: [],
          fileGroupId: "",
        },
      ], //分组
      tree: [],
      // 列表key
      mix_listKey: "materials",

      // 列表唯一字段
      mix_listId: "fileId",
      materials: [], //素材库
      // 默认查询参数
      mix_query: {
        fileGroupId: "",
        fileName: "",
        fileType: "",
      },
    };
  },
  computed: {
    fileType() {
      var type = "";
      switch (this.mix_query.fileType) {
        case "image":
          type = "图片";
          break;
        case "video":
          type = "视频";
          break;
        case "web":
          type = "网页";
          break;
        case "audio":
          type = "音乐";
          break;
        default:
          break;
      }
      return type;
    },
  },
  async created() {
    var fileType = this.$route.query.fileType;
    this.mix_query.fileType = fileType;
    //    请求分组列表
    await this.getFileGroup();
    //    请求素材列表
    await this.getFiles();

    if (this.mix_query.fileType == "image") {
      this.data.duration = 15;
    }
  },
  methods: {
    initData() {},
    //自动获取播放时长
    getDuration: function (e, item) {
      if (this.mix_query.fileType == "video") {
        this.data.duration = item.duration / 1000;
      }
      if (this.mix_query.fileType == "audio") {
        this.data.duration = item.duration / 1000;
      }
    },
    getFiles: function () {
      var _this = this;
      // 默认搜索的数据
      const search = {
        pageNum: this.mix_page,
        pageSize: this.mix_pageSize,
        ...this.mix_query,
      };

      material
        .getFileByPage(search)
        .then(function (ret) {
          _this.materials = _this.mix_format(ret.data.list);
          _this.mix_total = ret.data.total;
          _this.mix_page = ret.data.pageNum;
          _this.mix_pageSize = ret.data.pageSize;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //  获取素材分组
    getFileGroup: function () {
      var _this = this;
      //    请求分组列表
      material
        .getFileGroup()
        .then(function (success) {
          success.data.map(function (item) {
            item.children = [];
          });
          // 更新分组
          _this.tree = success.data;
          _this.list[0].children = _this.tree;
          _this.id++;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //分页切换
    pageChange: function (page, pageSize) {
      this.mix_page = page;
      this.mix_pageSize = pageSize;
      this.getFiles();
    },
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },
    submit: function () {
      var _this = this;
      //验证命名空间
      this.$validator
        .validateAll()
        .then((validate) => {
          if (validate) {
            return this.data;
          } else {
            let error = this.errors.items[0].msg;
            return false;
          }
        })
        .then((formData) => {
          if (formData) {
            //验证是否选择素材
            var materials = document.getElementsByName("material");
            var checked = null;
            for (let x of materials) {
              if (x.checked) {
                checked = JSON.parse(x.value);
                break;
              }
            }
            if (!checked) {
              _this.$message.error("请选择素材");
              return;
            }
            //    提交
            var returnData = { ...checked, ..._this.data };

            returnData.duration = Number(returnData.duration * 1000);
            switch (_this.mix_query.fileType) {
              case "image":
                parent.window.imageUploadSubmit(returnData);
                break;
              case "video":
                parent.window.videoUploadSubmit(returnData);
                break;
              case "web":
                parent.window.webUploadSubmit(returnData);
                break;
              case "audio":
                parent.window.audioUploadSubmit(returnData);
                break;
              default:
                break;
            }
            this.layerClose();
          }
        });
    },
    //  树形插件折叠的回调
    toggleFunc: function (data) {},
    //    树形点击文字的回调
    selectFunc: function (data) {
      this.mix_page = 1;
      this.mix_query.fileGroupId = data.fileGroupId;
      this.getFiles();
    },
    //    点击选择框的回调
    checkFunc: function (data) {},
    //    更新父组件的数据
    updateData: function (data) {},
    //    初始化完成后的回调
    hasInit: function (data) {},
  },
};
</script>

<style lang="scss" scoped>
.groups {
  width: 213px;
  border-right: 1px solid #eef2f9;
}
.materials {
  margin-right: -17px;
  flex-wrap: wrap;
  .material-item {
    width: calc((100% - 3 * 17px) / 3);
    /*width: 222px;*/
    height: 127px;
    margin: 0 17px 17px 0;
    position: relative;
    overflow: hidden;
    background: #eff2f8;
    text-align: center;
    &:nth-child(3n + 3) {
      /*margin-right: 0;*/
    }
    img {
      // width: 100%;
      height: 100%;
      // object-fit: contain;
    }
    input {
      position: absolute;
      right: 9px;
      top: 9px;
    }
    .material-item-info {
      position: absolute;
      bottom: 0;
      height: 21px;
      width: 100%;
      background-color: #000000;
      opacity: 0.65;
      color: #ffffff;
      font-size: 12px;
      padding: 0 9px;
      line-height: 21px;
    }
  }
}
</style>
